module.exports = __webpack_public_path__ + "static/img/8.bc5b9a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/8.png
// module id = uPYd
// module chunks = 0